/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../../../common/constants';
import utils from '../../../../common/utils';
import handleEvalReportError from './evalErrors';

export default class EvalResultListService extends BaseService {
  constructor() {
    super(constants.GET_EVAL_REPORT_LIST, 'EvalReportListStatus');
  }

  async handleEvent(eventName, event) {
    const { graphId, tenantId, version, startDate, endDate, rubricName } = event;
    const headers = utils.buildHeadersWithTenantId({ tenantId });
    const payload = {
      ...(graphId ? { graphId } : {}),
      version,
      startDate,
      endDate,
      rubricName
    };
    const { isStackB } = utils.getStackBParams();

    if (isStackB) {
      const enhancedHeaders = await utils.resolveStackBHeaders(headers);
      return this.getClient('aiadminstackbv2').post(constants.EVAL_REPORT_LIST_URL, payload, {
        headers: enhancedHeaders
      });
    }
    return this.getClient('aiadmin').post(constants.EVAL_REPORT_LIST_URL, payload, { headers });
  }

  handleResponse(response) {
    Framework.getStoreRegistry().getStore('evalResultData').setExecutionListResponse(response.data);
  }

  handleError(error) {
    handleEvalReportError(error);
    Framework.getStoreRegistry().getStore('evalResultData').setExecutionListResponse([]);
  }
}
